var app = angular.module('directives.banner',[]);
require('slick-carousel');
require('./directives/direct.js');
require('slick-carousel/slick/slick.css');
module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/main.baner/index.js
 ** module id = 179
 ** module chunks = 1
 **/